<template>
  <a-modal
    title="修改菜单"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          v-show="!addable"
          label="id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['menuId']"
            :disabled="editable || showable"
          />
        </a-form-item>
        <a-form-item
          label="上级菜单"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-tree-select
            :disabled="showable"
            showSearch
            placeholder="选择上级菜单"
            allowClear
            :treeData="treeData"
            treeDefaultExpandAll
            treeNodeFilterProp="title"
            v-decorator="['parentId', {rules: [{required: true, message: '请选择上级菜单'}],initialValue: '0'}]"
          />
        </a-form-item>
        <a-form-item
          label="菜单名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['title', {rules: [{required: true, message: '请输入菜单名称'}]}]" />
        </a-form-item>
        <a-form-item
          label="菜单类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            @change="selectChange"
            :disabled="showable"
            v-decorator="['type', {rules: [{required: true, message: '选择类型'}],initialValue: 1}]"
            :options="typeList"
          />
        </a-form-item>
        <a-form-item
          v-show="!(menuType === 2)"
          label="菜单路由"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['path', {rules: [{required: true, message: '请输入菜单路由'}]}]" />
        </a-form-item>
        <a-form-item
          v-show="!(menuType === 2)"
          label="路由名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['name', {rules: [{required: true, message: '请输入路由名称'}]}]" />
        </a-form-item>
        <a-form-item
          v-show="menuType === 1"
          label="是否隐藏本菜单"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checkedChildren="隐藏"
            :disabled="showable"
            unCheckedChildren="显示"
            v-decorator="['hidden', {initialValue: false}]" />
        </a-form-item>
        <a-form-item
          v-show="menuType === 1"
          label="是否隐藏子菜单"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checkedChildren="隐藏"
            :disabled="showable"
            unCheckedChildren="显示"
            v-decorator="['hideChildrenInMenu', {initialValue: false}]" />
        </a-form-item>
        <a-form-item
          v-show="!(menuType === 2)"
          label="图标"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="点击右侧按钮选择图标"
            v-decorator="['icon', {rules: [{required: true, message: '请选择菜单图标'}]}]" >
            <a-icon
              slot="addonAfter"
              type="setting"
              @click="selectIcons"
              :disabled="showable"
            />
          </a-input>
        </a-form-item>
        <a-form-item
          label="权限"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['perms', {rules: [{required: true, message: '请输入菜单权限'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>

    <template slot="footer">
      <div v-show="!showable">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
    <icon-modal
      ref="iconModal"
      @ok="iconChonse"/>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { addObj, putObj, getObj, fetchTree } from '@api/sys/menu'
import { treeDataTranslate } from '@/utils/util'
import iconModal from './icon/iconModal'
export default {
  name: 'MenuAddOrUpdate',
  components: {
    iconModal
  },
  data () {
    return {
      typeList: [
        {
          label: '目录',
          value: 0
        },
        {
          label: '菜单',
          value: 1
        },
        {
          label: '按钮',
          value: 2
        }
      ],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      type: 'add',
      editable: false,
      addable: false,
      showable: false,
      menuType: 1,
      treeData: []
    }
  },
  methods: {
    edit (id, type) {
      this.visible = true
      if (type && type === 'add') {
        this.addable = true
        this.type = type
      }
      if (type === 'edit') {
        this.editable = true
        this.type = type
      }
      if (type === 'show') {
        this.showable = true
        this.type = type
      }
      fetchTree().then(res => {
        this.treeData = treeDataTranslate(res.data, 'menuId', 'title')
      })
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          // 更改是否隐藏类型
          record.hidden = record.hidden === 1
          // 更改是否隐藏子路由状态
          record.hideChildrenInMenu = record.hideChildrenInMenu === 1
          this.menuType = record.type
          record.parentId = String(record.parentId)
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['menuId', 'title', 'type', 'path', 'name', 'hidden', 'icon', 'perms', 'hideChildrenInMenu', 'parentId']))
          })
        })
      } else {
        this.menuType = 1
        resetFields()
      }
    },
    selectChange (e) {
      this.menuType = e
    },
    handleOk () {
      const validateFieldsKey = this.menuType === 1
        ? ['menuId', 'title', 'type', 'path', 'name', 'hidden', 'icon', 'perms', 'hideChildrenInMenu', 'parentId']
        : ['menuId', 'title', 'type', 'path', 'name', 'perms', 'icon', 'parentId']
      this.form.validateFields(validateFieldsKey, async (err, values) => {
        if (!err) {
          console.log(values, 'values')
          if (values.type === 1) {
            if (values.hidden) {
              values.hidden = 1
            } else {
              values.hidden = 0
            }
            // 更改是否隐藏子路由状态
            if (values.hideChildrenInMenu) {
              values.hideChildrenInMenu = 1
            } else {
              values.hideChildrenInMenu = 0
            }
          }

          if (this.type === 'add') {
            await addObj(values)
          } else if (this.type === 'edit') {
            await putObj(values)
          }
          this.confirmLoading = true
          setTimeout(() => {
            this.confirmLoading = false
            this.$emit('ok')
            this.visible = false
          }, 1500)
        }
      })
    },
    handleCancel () {
      this.visible = false
      console.log('asdasd')
      setTimeout(() => {
        this.addable = false
        this.showable = false
        this.editable = false
      }, 200)
    },
    iconChonse (icon) {
      this.form.setFieldsValue({
        icon: icon
      })
    },
    selectIcons () {
      this.$refs.iconModal.init()
    }
  }
}
</script>

<style scoped>

</style>
